<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-card>
        <v-card-title class="text-center">Xocolata desfeta</v-card-title>
        <v-card-text>
          <p class="text-center">
            Espessa i lluent,
            <br />tothom se la menja,
            <br />ai!, a cremadent.
            <br />
            <br />En xicra o en tassa
            <br />prou que ho diu la gent,
            <br />mai no n'hi ha massa.
            <br />
            <br />S'hi poden sucar
            <br />galetes, melindros,
            <br />o bé un tros de pa.
            <br />
            <br />És bona al matí
            <br />i quan s'hi berena
            <br />té un gustet molt fi.
            <br />
            <br />Espessa i lluent,
            <br />tothom se la menja,
            <br />ai,! a cremadent.
            <br />
          </p>
          <p class="text-right">Miquel Martí i Pol</p>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
